/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeteringPointSubType = {
    NotSpecified: 'NotSpecified',
    Physical: 'Physical',
    Virtual: 'Virtual',
    Calculated: 'Calculated',
} as const;
export type MeteringPointSubType = typeof MeteringPointSubType[keyof typeof MeteringPointSubType];

